module.exports = __webpack_public_path__ + "img/hero03__1615360359_203.109.44.209.1a730d68.jpg";